module.exports = __webpack_public_path__ + "img/index-t-slide4.bfba1d97.jpg";